module.exports = __webpack_public_path__ + "a79e1d65.ttf";